import Styled from "./styles";
import MainContainer from "../../common/MainContainer";
import { Grid } from "@mui/material";
import SubHeading from "../../common/SubHeadings";
import About from "../About";
import { GetWorks } from "../../common/formJson/Autoload/GetWorks";
import DynamicForm from "../DynamicForm";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import defaultImg from "../../assets/images/default-img.jpg";

const Works = () => {
  const works = useSelector(
    ({ dynamicForms }) => dynamicForms?.getWorks?.results?.data
  );

  return (
    <Styled>
      <DynamicForm
        autoload={GetWorks?.formInp[0]?.inp?.service?.Autoload}
        formObj={GetWorks}
      />
      <MainContainer padding="40px 0px 30px">
        <div className="triangle-parent-div">
          <div className="triangle-up"></div>
        </div>
        <About />
        <Grid container className="works-container" id="works">
          <SubHeading fpart="My works" spart="Recent works" sColSwap={true} />
          {works ? (
            works?.map((val, index) => {
              const imageUrl = `${process.env.REACT_APP_DRIVE_FILE}${val?.image}`;
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={4}
                  key={index}
                  className="work-grid-item"
                >
                  <div className="work-card">
                    <div className="work-image-container">
                      <img
                        src={imageUrl}
                        className="work-img"
                        alt={val?.title || "Work image"}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = defaultImg;
                        }}
                      />
                      <div className="work-overlay">
                        <div className="work-content">
                          <h3 className="work-title">{val?.title}</h3>
                          <a
                            className="work-btn"
                            href={val?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Project
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              );
            })
          ) : (
            <Loader />
          )}
        </Grid>
      </MainContainer>
    </Styled>
  );
};

export default Works;
